import axios from "axios";
import AES from "crypto-js/aes";
import {
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  LOGOUT_SUCCESS,
  SET_STATUSNCOLOR,
  SET_ERROR,
  SET_LOGOUT_CLEAR,
  SET_SIP_PARAM,
} from "../Types/AuthTypes";
import { CLEAR_CHATSTATE } from "../Types/ChatTypes";
import { toast } from "react-toastify";

const apiUrlAuth = process.env.REACT_APP_API_URL + "auth/";

export const userLogin = (username, password, inapp) => {
  return async (dispatch) => {
    try {
      let url = "";
      let data = {};
      let headerParameter = null;
      if (!inapp) {
        data = { username: username, password: password };
        url = `${apiUrlAuth}login`;
      } else {
        data = { username: username };
        url = `${apiUrlAuth}logininapp`;
        headerParameter = {
          headers: { Authorization: `Bearer ${password}` },
        };
      }
      const response = await axios.post(url, data, headerParameter);
      if (response.data.status) {
        if (!inapp) {
          if (localStorage.getItem("token")) {
            return dispatch({
              type: USER_LOGIN_FAIL,
              payload: {
                errorMessage: "token difference",
              },
            });
          } else {
            localStorage.setItem("token", response.data.data.accessToken);
            // localStorage.setItem("time", response.data.data.currentstatetime);
            localStorage.setItem(
              "agentStatus",
              JSON.stringify({ time: response.data.data.currentstatetime })
            );
          }
        } else {
          localStorage.setItem("token", response.data.data.accessToken);
          localStorage.setItem("app", inapp);
        }

        let encryptedSip = null;
        const parameter = await systemParameter(331);
        dispatch({ type: SET_SIP_PARAM, payload: parameter.data });

        if (response.data.data.sipAccount) {
          encryptedSip = AES.encrypt(
            JSON.stringify(response.data.data.sipAccount),
            parameter.data
          ).toString();
        }

        dispatch({
          type: USER_LOGIN_SUCCESS,
          payload: {
            token: response.data.data.accessToken,
            successMessage: inapp ? "" : "Login Success!",
            // sipAccount: response.data.data.sipAccount || null // prev payload, unencrypted
            sipAccount: encryptedSip,
          },
        });
      }
    } catch (error) {
      let errorMsg =
        "API userLogin: " +
        (error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed Login!");
      if (
        error.message
          ? error.message.startsWith("Invalid token specified") //if tokenDecode failed
          : false
      ) {
        localStorage.clear();
        errorMsg = "Invalid User!";
      }
      dispatch({
        type: USER_LOGIN_FAIL,
        payload: {
          errorMessage: errorMsg,
        },
      });
    }
  };
};

export const userLogout = () => {
  return async (dispatch) => {
    try {
      const headerParameter = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      const bodyParameters = {};
      const response = await axios.post(
        `${apiUrlAuth}logout`,
        bodyParameters,
        headerParameter
      );
      if (response.data.status) {
        localStorage.clear();
        sessionStorage.removeItem("chatInternal");
        dispatch({
          type: LOGOUT_SUCCESS,
        });

        toast.success("Logged Out", { autoClose: 3000 });
      }
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: {
          errorMessage:
            "API userLogout: " +
            (error.response
              ? error.response.data.error
              : error.message
              ? error.message
              : "Failed Logout!"),
        },
      });

      toast.error("Error log out", { autoClose: 3000 });
    }
  };
};
export const agentState = async () => {
  try {
    const headerParameter = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const response = await axios.get(
      `${apiUrlAuth}agentstate`,
      headerParameter
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error: error.response
        ? "AgentState " + error.response.data.error
        : "AgentState Failed AgentState!",
    };
  }
};
export const stateAction = (
  statusState,
  statusReason,
  agentStatus,
  colors,
  info
) => {
  return async (dispatch) => {
    try {
      console.log(
        "data di hit:",
        statusState,
        statusReason,
        agentStatus,
        colors,
        info
      );
      const headerParameter = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      let LastdataState;
      let LastdataReason;
      if (agentStatus) {
        const splitStatus = agentStatus.split(" - ");
        LastdataState = splitStatus[0];
        LastdataReason = splitStatus[1];
      }
      LastdataState = LastdataState || "NOT BOUND";
      // let currenttime = parseInt(localStorage.getItem("time")) || 0;
      let currenttime =
        parseInt(JSON.parse(localStorage.getItem("agentStatus"))?.time) || 0;
      // if (!(statusState === LastdataState && statusReason === LastdataReason)) {
        const bodyParameters = {
          State: statusState,
          StateReason: statusReason,
          LastState: LastdataState,
          LastStateReason: LastdataReason,
          LastStateTime: currenttime,
        };
        const response = await axios.post(
          `${apiUrlAuth}stateaction`,
          bodyParameters,
          headerParameter
        );
        console.log("response stateaction", response);
        if (response.data.status) {
          if (response.data.data.currentstatetime) {
            // localStorage.setItem("time", response.data.data.currentstatetime);

            // localStorage.setItem(
            //   "container",
            //   statusState + (statusReason ? " - " + statusReason : "")
            // );

            // localStorage.setItem("colors", colors);

            localStorage.setItem(
              "agentStatus",
              JSON.stringify({
                time: response.data.data.currentstatetime,
                container:
                  statusState + (statusReason ? " - " + statusReason : ""),
                colors: colors,
                prevStatus: agentStatus
              })
            );

            dispatch({
              type: SET_STATUSNCOLOR,
              payload: {
                CurrentState:
                  statusState + (statusReason ? " - " + statusReason : ""),
                CurrentColor: colors,
              },
            });
          }
        }
      // }
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: {
          errorMessage:
            "API stateAction: " +
            (error.response.data
              ? error.response.data.error
              : error.message
              ? error.message
              : "Failed Change!"),
        },
      });
    }
  };
};

export const changePassword = async (OldpwdInput, pwdInput, pwdInput2) => {
  try {
    const headerParameter = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const bodyParameters = {
      oldpassword: OldpwdInput,
      newpassword: pwdInput,
      confirmpassword: pwdInput2,
    };
    const response = await axios.post(
      `${apiUrlAuth}changepassword`,
      bodyParameters,
      headerParameter
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API changePassword: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const unlockAgent = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrlAuth}unlockagent`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API unlockAgent: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const accessMenu = async (fkgroupmenuid) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlAuth}accessmenu`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API accessMenu: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const agentLeader = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrlAuth}agentleader`, config);
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API agentLeader: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const agentPermission = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrlAuth}agentpermission`, config);
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API agentPermission: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const systemParameter = async (id) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlAuth}systemparameter?id=${id}`,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API systemParameter: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const changeAgentStatus = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrlAuth}changeagentstatus`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API changeAgentStatus: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};
